import { buildSignInUrl } from '@/services/customerApiCompat'
import { logger } from '@/services/logger'

export const getTokenErrorHandler = async (error: unknown) => {
  logger.error(error)
  window.location.href = buildSignInUrl({ redirect: window.location.href })

  // Temporary
  // @TODO: we must update getJwt in core common-front "src/services/http/request-interceptor/bearer-token-interceptor.ts"
  // the errorHandler should only be called without thinking it can return a token
  throw new Error(
    `getTokenErrorHandler - Customer-account: User Authentication is required : ${error}`
  )
}
